import { notify } from 'utils/reduxUtils';

export const types = {
  DEEP_COPY_QUOTE_ITEM_ERROR:
    'baq/sideNav/deepCopyModal/DEEP_COPY_QUOTE_ITEM_ERROR',
  DEEP_COPY_QUOTE_ITEM_REQUEST:
    'baq/sideNav/deepCopyModal/DEEP_COPY_QUOTE_ITEM_REQUEST',
  DEEP_COPY_QUOTE_ITEM_SUCCESS:
    'baq/sideNav/deepCopyModal/DEEP_COPY_QUOTE_ITEM_SUCCESS',

  MODAL_CLOSE: 'baq/sideNav/deepCopyModal/MODAL_CLOSE',
  MODAL_OPEN: 'baq/sideNav/deepCopyModal/MODAL_OPEN',
};

export const deepCopyModal = {
  open: ({ quoteItemId }) => ({
    type: types.MODAL_OPEN,
    payload: { quoteItemId },
  }),
  close: () => ({
    type: types.MODAL_CLOSE,
  }),
};

export const deepCopyQuoteItem = {
  error: notify(
    (error) => ({
      type: types.DEEP_COPY_QUOTE_ITEM_ERROR,
      payload: error,
    }),
    'Failed to deep copy quote item',
  ),
  request: () => ({
    type: types.DEEP_COPY_QUOTE_ITEM_REQUEST,
  }),
  success: () => ({
    type: types.DEEP_COPY_QUOTE_ITEM_SUCCESS,
  }),
};
